import { getYear, isValid, startOfMonth } from "date-fns";
import { useState } from "react";
import { resolveInitialPanelDate } from "web_myplann/Shared/Components/FlatRow/resolveInitialPanelDate";
import {
	type DatePanelMode,
	DateView,
} from "web_myplann/Shared/Types/DateView";

type Params = {
	value: Date | null;
	mode: DatePanelMode;
	minDate?: Date;
	maxDate?: Date;
	onSelect: (date: Date) => void;
};

export const useDatePanelNavigation = ({
	value: rawValue,
	mode,
	minDate,
	maxDate,
	onSelect,
}: Params) => {
	const value = rawValue !== null && isValid(rawValue) ? rawValue : null;
	const [view, setView] = useState<DateView>(mode);
	const [visibleMonth, setVisibleMonth] = useState(() =>
		resolveInitialPanelDate(value, minDate, maxDate),
	);
	const [visibleYear, setVisibleYear] = useState(() => getYear(visibleMonth));
	const valueTime = value?.getTime() ?? null;
	const [shownValueTime, setShownValueTime] = useState(valueTime);

	if (valueTime !== shownValueTime) {
		setShownValueTime(valueTime);
		if (value !== null) {
			setVisibleMonth(startOfMonth(value));
			setVisibleYear(getYear(value));
			setView(mode);
		}
	}

	const showMonths = () => {
		setVisibleYear(getYear(visibleMonth));
		setView(DateView.Month);
	};

	const showYears = () => setView(DateView.Year);

	const selectYear = (year: number) => {
		setVisibleYear(year);
		setView(DateView.Month);
	};

	const selectMonth = (month: Date) => {
		if (mode === DateView.Month) {
			onSelect(month);
			return;
		}
		setVisibleMonth(month);
		setView(DateView.Day);
	};

	const selectDay = (day: Date) => {
		setVisibleMonth(startOfMonth(day));
		onSelect(day);
	};

	return {
		view,
		visibleMonth,
		visibleYear,
		highlightedMonth: mode === DateView.Day ? visibleMonth : value,
		setVisibleMonth,
		setVisibleYear,
		showMonths,
		showYears,
		selectYear,
		selectMonth,
		selectDay,
	};
};
